import { api } from './api'

export interface SyncSettings {
  // Per-data-source sync settings
  session_sync: {
    maryland: {
      [session: string]: boolean
    }
    federal: {
      [session: string]: boolean
    }
  }
  updated_at?: string
  updated_by?: string
}

export interface DebugSettings {
  enabled: boolean
  updated_at?: string
  updated_by?: string
}

// Transform function to handle both PascalCase and snake_case from backend
const transformSyncSettingsResponse = (data: any): SyncSettings => {
  return {
    session_sync: data.session_sync || data.SessionSync || {
      maryland: {},
      federal: {}
    },
    updated_at: data.updated_at || data.UpdatedAt,
    updated_by: data.updated_by || data.UpdatedBy
  }
}

const transformDebugSettingsResponse = (data: any): DebugSettings => {
  return {
    enabled: data.enabled || data.Enabled || false,
    updated_at: data.updated_at || data.UpdatedAt,
    updated_by: data.updated_by || data.UpdatedBy
  }
}

export const adminSettingsApi = {
  // Debug settings
  getDebugSettings: async (): Promise<DebugSettings> => {
    console.log('🔍 Fetching debug settings')
    const response = await api.get<any>('/settings/debug', {
      isGlobal: true
    })
    console.log('✅ Fetched debug settings:', response.data)
    return transformDebugSettingsResponse(response.data)
  },

  updateDebugSettings: async (enabled: boolean): Promise<DebugSettings> => {
    console.log(`🔄 Updating debug settings: ${enabled}`)
    const response = await api.post<any>(`/settings/debug?enabled=${enabled}`, null, { 
      isGlobal: true 
    })
    console.log('✅ Updated debug settings:', response.data)
    return transformDebugSettingsResponse(response.data)
  },

  // Sync settings
  getSyncSettings: async (): Promise<SyncSettings> => {
    console.log('🔍 Fetching sync settings')
    const response = await api.get<any>('/settings/sync', { 
      isGlobal: true 
    })
    console.log('✅ Fetched sync settings:', response.data)
    return transformSyncSettingsResponse(response.data)
  },

  updateSyncSettings: async (settings: {
    session_sync: {
      maryland: {
        [session: string]: boolean
      }
      federal: {
        [session: string]: boolean
      }
    }
  }): Promise<SyncSettings> => {
    console.log('🔄 Updating sync settings:', settings)
    const response = await api.post<any>('/settings/sync', settings, { 
      isGlobal: true 
    })
    console.log('✅ Updated sync settings:', response.data)
    return transformSyncSettingsResponse(response.data)
  }
}